// extracted by mini-css-extract-plugin
export default {"rate":"Rate_rate__7tzID","count":"Rate_count__jcOlr","votes":"Rate_votes__QJ4M4","stars":"Rate_stars__OaTQD"};